import React, { Fragment } from 'react';
import { Badge, Avatar, Button } from '@material-ui/core';
import { Theme, makeStyles, withStyles, createStyles } from '@material-ui/core/styles';
import './avatar-with-badge.scss'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Markup } from 'interweave';
import { IRootState } from 'app/shared/reducers';
import { capitalize } from 'app/shared/util/method-util';

const StyledBadge = withStyles((theme: Theme) =>
  createStyles({
    badge: {
      backgroundColor: '#44b700',
      height: '10px',
      width: '10px',
      maxHeight: '10px',
      maxWidth: '10px',
      minHeight: '10px',
      minWidth: '10px',
      borderRadius: '50%',
      color: '#44b700',
      boxShadow: `0 0 0 3px ${theme.palette.background.paper}`,
      right: '17%',
      bottom: '15%',
      '&::after': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        animation: '$ripple 1.2s infinite ease-in-out',
        border: '1px solid currentColor',
        content: '""',
      },
    },
    '@keyframes ripple': {
      '0%': {
        transform: 'scale(.8)',
        opacity: 1,
      },
      '100%': {
        transform: 'scale(2.4)',
        opacity: 0,
      },
    },
  }),
)(Badge);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      }
    },
    large: {
      height: 52,
      width: 52,
    }
  }),
);
export interface IAvatarWithBadgeProps {
  getPreviousStep?(): void;
  previousLink?: string;
  hideButton?: boolean;
  hideAvatar?: boolean;
  icon?: boolean;
  title?: string[];
  text?: string[];
  isTitlePadding?: boolean;
}


const AvatarWithBadge = (props: IAvatarWithBadgeProps) => {
  const { text: pText, title: pTitle, previousLink, hideAvatar, getPreviousStep, hideButton, icon, isTitlePadding } = props || {}
  const avatar = useSelector((state: IRootState) => state.cms.avatar);
  const subscriber = useSelector((state: IRootState) => state.kubrickManagement.subscriber);

  const history = useHistory();
  const classes = useStyles();

  const handleBack = () => {
    if (previousLink) {
      history.push(previousLink);
    } else {
      getPreviousStep();
    }
  }

  const checkTitleVars = (title: string) => {
    while (title.indexOf('{{') > 0) {
      const indexBracketsOpened = title.indexOf('{{');
      const indexBracketsClosed = title.indexOf('}}');
      const variableWithBrackets = title.substring(indexBracketsOpened, indexBracketsClosed + 2);
      const variable = title.substring(indexBracketsOpened + 2, indexBracketsClosed);
      title = title.replace(variableWithBrackets, capitalize(subscriber?.[variable]));
    }
    return title;
  }

  return (
    <div className={"header-avatar-badge" + ((((pTitle?.length > 0) || (pText?.length > 0)) && !isTitlePadding) ? " header-avatar-big-bottom-space" : " header-avatar-small-bottom-space")}>
      <div className="avatar">
        {!hideButton &&
          <Button id='btn-back' className='btn btn-back' onClick={handleBack}>
            <ArrowBackIcon />
          </Button>
        }
        {((pTitle?.length > 0) || (pText?.length > 0)) && (!hideAvatar) &&
          <div className={classes.root}>
            {/* <StyledBadge
              overlap="circle"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              variant="dot"> */}
            <Avatar className={classes.large} alt={avatar?.name} src={avatar?.photo} />
            {/* </StyledBadge> */}
          </div>
        }
      </div>
      {((pTitle?.length > 0) || (pText?.length > 0)) &&
        <div className="header-badge-text-box">
          {icon && <div className="check-icon"><img src={'/content/images/mobile-view/check.svg'} /></div>}
          {
            pTitle?.map((text, index) => {
              return (
                <div key={index} className="header-badge-title font-weight-bold"> <Markup content={checkTitleVars(text)} /></div>
              );
            })
          }
          {
            pText?.map((text, index) => {
              return (
                <Fragment key={index}>
                  <Markup content={text} />
                  <br />
                </Fragment>
              )
            })
          }
        </div>
      }
    </div>
  );
}
export default AvatarWithBadge;
